var _polygon, _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 192,
    height: 192,
    viewBox: "0 0 24 24",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.301,14.314 13.305,14.317 13.308,14.318"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kvjt7b2-jwZ-NqS9WvYZ0a_GE6eMUbWbBDw_gr1",
    x1: -32.051,
    x2: -32.033,
    y1: 577.702,
    y2: 577.683,
    gradientTransform: "matrix(805.5508 0 0 -795.1891 25828.787 459385.031)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a03c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7974e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kvjt7b2-jwZ-NqS9WvYZ0a_GE6eMUbWbBDw_gr1)",
    d: "M23.963,17.103c0.011-0.105,0.018-0.21,0.024-0.316c0.007-0.126-7.555-7.301-7.555-7.301h-0.181 C16.251,9.486,23.917,17.571,23.963,17.103L23.963,17.103z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kvjt7b2-jwZ-NqS9WvYZ0b_GE6eMUbWbBDw_gr2",
    x1: -31.985,
    x2: -31.951,
    y1: 580.773,
    y2: 580.74,
    gradientTransform: "matrix(392.6758 0 0 -394.6426 12557.653 229203.094)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a03c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7974e"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kvjt7b2-jwZ-NqS9WvYZ0b_GE6eMUbWbBDw_gr2)",
    d: "M7.828,14.614c-0.01,0.022-0.02,0.044-0.03,0.066c-0.011,0.023-0.022,0.046-0.033,0.069 c-0.241,0.503,3.375,4.038,3.666,3.608c0.013-0.019,0.027-0.039,0.04-0.058c0.015-0.023,0.029-0.044,0.044-0.067 C11.747,17.879,7.931,14.384,7.828,14.614L7.828,14.614z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kvjt7b2-jwZ-NqS9WvYZ0c_GE6eMUbWbBDw_gr3",
    x1: -33.237,
    x2: -33.207,
    y1: 582.149,
    y2: 582.114,
    gradientTransform: "matrix(400.7761 0 0 -389.963 13324.924 227026.39)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a03c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7974e"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kvjt7b2-jwZ-NqS9WvYZ0c_GE6eMUbWbBDw_gr3)",
    d: "M12.938,19.585c-0.01,0.023-0.083,0.146-0.149,0.211c-0.011,0.023,3.53,3.534,3.53,3.534h0.319 C16.637,23.33,13.313,19.733,12.938,19.585z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kvjt7b2-jwZ-NqS9WvYZ0d_GE6eMUbWbBDw_gr4",
    x1: -29.987,
    x2: -29.98,
    y1: 576.184,
    y2: 576.175,
    gradientTransform: "matrix(2498.3396 0 0 -2363.3909 74920.188 1361747.375)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26d58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a03c"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kvjt7b2-jwZ-NqS9WvYZ0d_GE6eMUbWbBDw_gr4)",
    d: "M23.992,16.723c-0.166,3.671-3.203,6.607-6.913,6.607h-0.502l-3.706-3.651 c0.305-0.43,0.588-0.875,0.84-1.34h3.367c1.065,0,1.931-0.866,1.931-1.931c0-1.065-0.867-1.931-1.931-1.931h-1.992 c0.152-0.802,0.235-1.63,0.235-2.477c0-0.859-0.084-1.699-0.242-2.514h1.238l7.653,7.541C23.98,16.926,23.987,16.825,23.992,16.723 L23.992,16.723z M2.013,0.633H0v4.99h2.013c3.516,0,6.377,2.86,6.377,6.376c0,0.957-0.213,1.865-0.593,2.68l3.673,3.619 c1.206-1.804,1.911-3.971,1.911-6.299C13.381,5.732,8.281,0.633,2.013,0.633z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kvjt7b2-jwZ-NqS9WvYZ0e_GE6eMUbWbBDw_gr5",
    x1: -30.566,
    x2: -30.556,
    y1: 576.254,
    y2: 576.247,
    gradientTransform: "matrix(1569.598 0 0 -1707.1244 47987.484 983737.938)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b84e51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f68e48"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kvjt7b2-jwZ-NqS9WvYZ0e_GE6eMUbWbBDw_gr5)",
    d: "M17.079,0.633H8.927c1.991,1.216,3.64,2.939,4.763,4.99h3.389c1.065,0,1.931,0.866,1.931,1.931 c0,1.065-0.867,1.931-1.931,1.931h-0.761l7.653,7.541C23.989,16.823,24,16.617,24,16.408c0-1.682-0.604-3.226-1.606-4.427 C23.396,10.781,24,9.237,24,7.555C24,3.739,20.895,0.633,17.079,0.633z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "kvjt7b2-jwZ-NqS9WvYZ0f_GE6eMUbWbBDw_gr6",
    x1: -29.978,
    x2: -29.978,
    y1: 578.079,
    y2: 578.067,
    gradientTransform: "matrix(1726.1868 0 0 -904.572 51755.605 522930.438)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a03c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7974e"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#kvjt7b2-jwZ-NqS9WvYZ0f_GE6eMUbWbBDw_gr6)",
    d: "M16.577,23.33H8.985c1.528-0.944,2.849-2.19,3.887-3.651L16.577,23.33L16.577,23.33z M11.47,18.299 L7.798,14.68c-1.015,2.18-3.226,3.697-5.785,3.697H0v4.99h2.013C5.953,23.367,9.43,21.352,11.47,18.299z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3);
export default __webpack_public_path__ + "static/media/d3.4cd3216e564f7dbfe9c1a9dc8d79a904.svg";
export { ForwardRef as ReactComponent };